<template>
  <orders-base-view status="canceled"></orders-base-view>
</template>

<script>

import OrdersBaseView from "@/components/orders/OrdersBaseView";
export default {
  name: 'OrdersCanceledView',

  components: {OrdersBaseView},
};
</script>
